import { Injectable, ApplicationRef, Inject, PLATFORM_ID, NgZone } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { BehaviorSubject } from "rxjs";
import { filter, take } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class PrebootService {
    private isBrowser: boolean;
    private isComplete: boolean;
    private isStable: boolean;
    public transitionComplete: BehaviorSubject<boolean> = new BehaviorSubject(false);
    constructor(
        private appRef: ApplicationRef,
        @Inject(PLATFORM_ID) private platformId: any,
        //private uiHelper: UiHelperService,
        private zone: NgZone) {
        this.isBrowser = isPlatformBrowser(platformId);
        if (this.isBrowser) {
            this.appRef.isStable.pipe(filter(stable => stable), take(1)).subscribe(() => {
                this.isStable = true;
                console.log('preboot service stable');
                this.transitionToClient();
            });
        }
    }

    private transitionToClient() {
        if (this.isComplete) {
            return;
        }
        console.log('transition server to client');
        this.transitionComplete.next(true);
        this.isComplete = true;
    }

    public forceTransitionComplete(delay: number) {
        if (!this.isBrowser) {
            return;
        }
        if (!delay || isNaN(Number(delay))) {
            this.transitionToClient();
            return;
        }
        this.zone.runOutsideAngular(() => {
            setTimeout(() => {
                this.zone.run(() => {
                    console.log('force complete');
                    this.transitionToClient();
                });
            }, delay);
        });
        
    }
}
